import type { ContactEmailEntity } from './entity_types/ContactEmail';
import type { UserEntity } from './entity_types/User';
import { hFetch } from './hFetch';

export type GetContactEmailsResponse = ContactEmailEntity & { user: UserEntity };
export const getContactEmails = (contactId: string) => {
  return hFetch<GetContactEmailsResponse[]>({ url: `/api/contact_emails/${contactId}` });
};
